export default __webpack_public_path__ + "static/media/notes.1e389efa.svg";